const { getElement } = window.BAO.Utils

export class ProductForm extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.form, 'submit', this.onSubmitHandler.bind(this))
  }

  checkValidity () {
    super.checkValidity()

    if (!this.form) {
      this.throwError(`needs to be wrapped around a product's <form> element`)
    }
  }

  async onSubmitHandler (e) {
    e.preventDefault()

    this.toggleButtonText()
    await this.addToCart()
  }

  async addToCart () {
    try {
      await window.BAO.Cart.addItemFromForm(this.form)
    } catch (error) {
      console.error('Error adding item to cart:', error)
    }
  }

  toggleButtonText () {
    const buttonText = this.querySelector('[data-product-add-to-cart-text]')
    if (
      !buttonText ||
      !window.variantStrings.addToCart ||
      !window.variantStrings.added
    ) {
      return
    }

    const preorder = getElement(
      `[data-pre-order="true"][data-variant-id='${this.id}']`,
    )

    buttonText.innerText = window.variantStrings.added

    window.setTimeout(() => {
      if (preorder) {
        buttonText.innerText = window.variantStrings.preOrder
      } else {
        buttonText.innerText = window.variantStrings.addToCart
      }
    }, 3000)
  }

  get id () {
    const formData = new FormData(this.form)

    return formData.get('id')
  }

  /**
   * @returns {HTMLFormElement|null}
   */
  get form () {
    return this.querySelector('form')
  }
}

customElements.define('product-form', ProductForm)
